import React, { useRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Carousel from 'react-material-ui-carousel';
import { Box, Typography, Card, CardMedia, Stack } from '@mui/material';

const items = [
  {
    name: 'Accepted Answer Formats',
    description:
      'Capitalizations, spaces, and punctuations (except "&") are not required',
    imageUrl:
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1685122450/Tip1_fhbnu2.gif',
  },
  {
    name: 'Spelling Leniency',
    description: `Close-ish spellings are accepted. Read more about the "Precision" system in the Help page`,
    imageUrl:
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1687579640/Tip7_pdypn1.gif',
  },
  {
    name: 'Leading Articles Can Be Ommitted',
    description: `If an answer starts with "The", "An" or "A", you don't have to type it`,
    imageUrl:
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1685122450/Tip2_mriesi.gif',
  },
  {
    name: 'The "Be More Specific" Prompt',
    description: `If you get a "Be more specific" prompt, you only need to type in the remaining answer.`,
    imageUrl:
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1685076596/bush_BMS_qvsqz1.gif',
  },

  {
    name: 'Delete Your Answer Quickly',
    description: `Ctrl/Cmd + Backspace will delete the entire answer`,
    imageUrl:
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1685122450/Tip4_qzzxep.gif',
  },
  {
    name: 'Highlight and Type Over Your Answer',
    description: `Ctrl/Cmd + A will highlight the entire answer, then you can type over it. (Fast typist might prefer this because this action can be done with one hand)`,
    imageUrl:
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1685122450/Tip5_ltixrg.gif',
  },
  {
    name: 'Jump Cursor to Previous Word',
    description: `Alt/Option + Left Arrow Key will jump your cursor to the beginning of the word. Do it again to move to the previous word. This works with the Right Arrow Key as well`,
    imageUrl:
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1685122450/Tip6_qr6j8n.gif',
  },
  {
    name: 'Alternate Accepted Answers',
    description: `The more you play, the more you'll notice certain patterns in how answers are accepted`,
    imageUrl:
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1687579876/Tip8_dmo91e.gif',
  },
  {
    name: 'Even More Alternate Accepted Answers',
    description: `Get creative, sometimes you'll be surprised what gets accepted!`,
    imageUrl:
      'https://res.cloudinary.com/dqlqwdqs9/image/upload/v1687580099/Tip9_epmhqd.gif',
  },
];

type PropTypes = {
  close: () => void;
  open: boolean;
};

export const HelpfulTipsDialog = ({ close, open }: PropTypes) => {
  // this hack is needed to work around the carousel height bug:
  //  https://github.com/Learus/react-material-ui-carousel/issues/189
  const [firstImgLoaded, setFirstImgLoaded] = useState(false);

  return (
    <Dialog open={open} onClose={close} maxWidth="lg" fullWidth>
      <DialogContent>
        <img
          src={items[0].imageUrl}
          onLoad={() => setFirstImgLoaded(true)}
          style={{ display: 'none' }}
          alt="first"
        />
        {firstImgLoaded && (
          <Carousel navButtonsAlwaysVisible autoPlay={false}>
            {items.map((item, i) => (
              <Box
                sx={{
                  justifyContent: 'center',
                }}
              >
                <Stack
                  spacing={2}
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  <Typography variant="h4">{item.name}</Typography>
                  <Typography fontWeight={600}>{item.description}</Typography>
                  <Card variant="outlined" sx={{ paddingY: 2 }}>
                    <CardMedia
                      component="img"
                      image={item.imageUrl}
                      alt={item.name}
                    />
                  </Card>
                </Stack>
              </Box>
            ))}
          </Carousel>
        )}
      </DialogContent>
    </Dialog>
  );
};
